import React from 'react'
import { useTranslatedText } from '../OracleCommons/StaticTextContext'
import OracleIconButton from '../OracleCommons/OracleIconButton'

interface OracleVoiceInputProps {
  className?: string
  disabled?: boolean
  onVoiceClick?: () => void
}

const OracleVoiceInput: React.FC<OracleVoiceInputProps> = ({
  className = '',
  disabled = false,
  onVoiceClick,
}) => {
  const voiceInputAriaLabel = useTranslatedText({ keys: ['chatInput', 'voiceInputAriaLabel'] })

  const handleVoiceClick = async () => {
    if (onVoiceClick) {
      onVoiceClick()
    }
  }

  return (
    <div className={`oracle-voice-input${className ? ` ${className}` : ''}`}>
      <OracleIconButton
        icon="voice"
        invert={true}
        border="circle"
        aria-label={voiceInputAriaLabel}
        onClick={disabled ? undefined : handleVoiceClick}
        className=""
      />
    </div>
  )
}

export default OracleVoiceInput
